// Module
var code = "<!-- ko if: ready -->\n<!-- ko template: { nodes: $componentTemplateNodes, data: $parent } -->\n<!-- /ko -->\n<!-- /ko -->\n\n<!-- ko if: !ready() && showLoading -->\n<!-- ko component: { name: \"loadingFillParent\" } -->\n<!-- /ko -->\n<!-- /ko -->\n";
// Exports
module.exports = code;